import { TableCell } from '@mui/material';
import { useUser } from 'features/userManagement/api/getUser';

interface Props {
  userId: number;
}

const UserTableCell = ({ userId }: Props) => {
  const { data: user } = useUser({ userId });
  return <TableCell>{user?.name || ''}</TableCell>;
};

export default UserTableCell;
